import React, { useState } from 'react';
import styles from './styles.module.css';

function OwnerExpandedRecord({ record, onClick }) {
  // R33: Use new owners array if available, otherwise fallback to people array
  const owners = record?.owners || [];
  const [isExpanded, setIsExpanded] = useState(false);

  // Fallback: Extract the owner person from the people array
  const ownerPerson = record?.people?.find(
    person => person.title?.toLowerCase() === 'owner'
  );

  // Determine if the owner person has a valid people_key
  const hasPeopleId = ownerPerson?.people_key;

  // Conditionally combine classes for the owner's name span
  const ownerNameClass = hasPeopleId
    ? `${styles.spanTypeValue} ${styles.OwnerExpandedClickable}`
    : styles.spanTypeValue;

  // Determine how many owners to show
  const displayedOwners = isExpanded ? owners : owners.slice(0, 5);
  const hasMoreOwners = owners.length > 5;

  return (
    <>
      {/* First section: Most Recent Owner, Owner type and Owner occupied inline fields */}
      <section className={styles.ownerMainContainer}>
        <div className={styles.gridItem}>
          <span className={styles.spanTitle}>Most recent owner</span>
          <span className={ownerNameClass} onClick={hasPeopleId ? onClick : undefined}>
            {ownerPerson?.name ||
              (ownerPerson?.firstName || ownerPerson?.lastName
                ? `${ownerPerson.firstName || ''} ${ownerPerson.lastName || ''}`.trim()
                : 'N/A')}
          </span>
        </div>

        <div className={styles.gridItem}>
          <span className={styles.spanTitle}>Owner type</span>
          <span className={styles.spanTypeValue}>
            {record?.currentOwnerType ? record.currentOwnerType : 'N/A'}
          </span>
        </div>

        <div className={styles.gridItem}>
          <span className={styles.spanTitle}>Owner occupied</span>
          <span className={styles.spanTypeValue}>
            {record?.ownerOccupied ? 'True' : 'N/A'}
          </span>
        </div>

        <div className={styles.gridItem}>
          <span className={styles.spanTitle}>Most recent agent</span>
          <span className={styles.spanTypeValue}>
            {record?.mostRecentBrokerAgent ? record.mostRecentBrokerAgent : 'N/A'}
          </span>
        </div>
      </section>

      {/* R33: Second section: Owners table display (always visible) */}
      <hr className={styles.hrOwners} />
      <section className={styles.containerOwnersSection}>
        <span className={styles.ownersTitle}>Owners</span>

        {owners.length === 0 ? (
          <div className={styles.noOwners}>N/A</div>
        ) : (
          <>
            <div className={styles.ownersTable}>
              {/* Table Header */}
              <div className={styles.headerRow}>
                <span className={styles.header}>First name</span>
                <span className={styles.header}>Last name</span>
                <span className={styles.header}>First date seen</span>
                <span className={styles.header}>Last date seen</span>
                <span className={styles.header}>Transaction date</span>
              </div>

              {/* Owner Rows */}
              {displayedOwners.map((owner, index) => {
                const hasClickableOwner = owner.peopleKey;
                return (
                  <div key={index} className={styles.ownerRow}>
                    <span
                      className={hasClickableOwner ? `${styles.cell} ${styles.clickableCell}` : styles.cell}
                      onClick={hasClickableOwner ? onClick : undefined}
                    >
                      {owner.firstName || 'N/A'}
                    </span>
                    <span
                      className={hasClickableOwner ? `${styles.cell} ${styles.clickableCell}` : styles.cell}
                      onClick={hasClickableOwner ? onClick : undefined}
                    >
                      {owner.lastName || 'N/A'}
                    </span>
                    <span className={styles.cell}>
                      {owner.firstDateSeen
                        ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit'
                          }).format(new Date(owner.firstDateSeen))
                        : 'N/A'}
                    </span>
                    <span className={styles.cell}>
                      {owner.lastDateSeen
                        ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit'
                          }).format(new Date(owner.lastDateSeen))
                        : 'N/A'}
                    </span>
                    <span className={styles.cell}>
                      {owner.transactionDate
                        ? new Intl.DateTimeFormat('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: '2-digit'
                          }).format(new Date(owner.transactionDate))
                        : 'N/A'}
                    </span>
                  </div>
                );
              })}
            </div>

            {hasMoreOwners && (
              <button
                className={styles.expandButton}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? 'Show less' : `Expand All (${owners.length})`}
              </button>
            )}
          </>
        )}
      </section>
    </>
  );
}

export default OwnerExpandedRecord;
